import '@babylonjs/core/Rendering/outlineRenderer.js';
import '@babylonjs/core/Lights/Shadows/shadowGeneratorSceneComponent.js';
import {Scene} from '@babylonjs/core/scene.js';
import {Engine} from '@babylonjs/core/Engines/engine.js';
import {Color3} from '@babylonjs/core/Maths/math.color.js';
import {Color4} from '@babylonjs/core/Maths/math.color.js';
import {HemisphericLight} from '@babylonjs/core/Lights/hemisphericLight.js';
import {DirectionalLight} from '@babylonjs/core/Lights/directionalLight.js';
import {Vector3} from '@babylonjs/core/Maths/math.vector.js';
import {MeshBuilder} from '@babylonjs/core/Meshes/meshBuilder.js';
import {StandardMaterial} from '@babylonjs/core/Materials/standardMaterial.js';
import {ShadowGenerator} from '@babylonjs/core/Lights/Shadows/shadowGenerator.js';
import {AbstractMesh} from '@babylonjs/core/Meshes/abstractMesh.js';
import {Environment} from './environment';
import {Assets} from './assets';
import {height,lots} from './world';
import {ChunkManager,terrain} from './chunks';
export async function createWorld(engine:Engine,progress:(text:string)=>void){
 const scene=new Scene(engine);scene.clearColor=new Color4(.63,.73,.77,1);
 scene.fogMode=Scene.FOGMODE_LINEAR;scene.fogColor=new Color3(.63,.73,.77);scene.fogStart=50;scene.fogEnd=130;
 const fill=new HemisphericLight('sky',new Vector3(0,1,0),scene);fill.intensity=.85;fill.groundColor=new Color3(.25,.28,.22);
 const sun=new DirectionalLight('sun',new Vector3(-.5,-1,.4),scene);sun.position.set(20,35,-20);sun.intensity=1.5;sun.autoCalcShadowZBounds=true;
 sun.shadowMinZ=1;sun.shadowMaxZ=100;
 const shadows=new ShadowGenerator(512,sun);shadows.usePoissonSampling=true;shadows.bias=.001;shadows.normalBias=.02;

 const assets=new Assets(scene);await assets.load(progress);
 const chunks=new ChunkManager(scene,assets);
 const dirt=assets.surfaceMaterial('elmir_road_10m').clone('shared-dirt')!;chunks.dirt=dirt;
 if(dirt instanceof StandardMaterial)dirt.diffuseColor=new Color3(.55,.4,.25);
 // PBR tint without replacing the source textures.
 if('albedoColor' in dirt)(dirt as any).albedoColor=new Color3(.65,.48,.3);
 const environment=new Environment(assets,shadows);
 const marker=new StandardMaterial('reserved-lot',scene);marker.diffuseColor=new Color3(.47,.42,.3);
 for(const lot of lots){
  const m=MeshBuilder.CreateGround('future-building-lot',{width:12,height:12},scene);
  m.position.set(lot.x,.04,lot.z);m.material=marker;m.isPickable=false;
 }
 // Initial neighbourhood only. Remaining cells are generated on demand.
 chunks.update(0,-11);while(chunks.snapshot().queued)chunks.pump();
 scene.fogStart=65;scene.fogEnd=110;
 return {scene,shadows,chunks,sun,environment,decor:scene.meshes.filter(m=>m.name==='future-building-lot')};
}
